import { useState, useContext, useEffect, useMemo } from 'react'
import { PassContext } from '../pass-context'
import _ from "lodash"

import { TextField, Typography, Button, Tooltip } from '@mui/material'
import EastRoundedIcon from '@mui/icons-material/EastRounded'
import PopupShell from '../popup-shell'

const PopupDialogText = ({ open, close, title }) => {

  const { classData, setClassData } = useContext(PassContext)

  const [newClassData, setNewClassData] = useState({})
  const [required,setRequired] = useState(false)
  const [valid,setValid] = useState(true)

  const dataChanged = useMemo(() => {
    if (open) {
      if (!_.isEqual(classData, newClassData)) return true
    }

    return false
  }, [newClassData])

  // Runs on "open" state change or if template / instanceData change 
  // Ensures we have the current data rather than something left behind from previous form 
  useEffect(() => {
    try {
      if (open) {
        setNewClassData(_.cloneDeep(classData))
      }
    }
    catch (err) {
      throw err
    }
  }, [open,classData])

  useEffect(() => {
    if (newClassData.venue) setRequired(true)
  },[newClassData])

  useEffect(() => {
    if (newClassData.venue) {
      if (newClassData.venue.name && newClassData.venue.address) setValid(true)
        else setValid(false)
    } else setValid(true)
  },[newClassData])


  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Support Functions
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  const updateClassDataValue = (field,value) => {

    let c = _.cloneDeep(newClassData)

    if (value.length) {
      _.set(c,`venue.${field}.defaultValue.value`,value)
      _.set(c,`venue.${field}.defaultValue.language`,"en-US")
    } else {
      _.unset(c,`venue.${field}`)
    }

    setNewClassData(c)
  }

  const saveFormData = () => {
    if (!_.isEqual(newClassData,classData)) setClassData(newClassData)
    close()
  }

  const handleClose = (e, reason) => {
    if (reason && reason === "backdropClick")
      return
    close()
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Main Render
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
      <PopupShell open={open} onClose={handleClose}>

        <div className="flex flex-col p-5 h-full">

          <div className="flex flex-row justify-between mt-5">
            <Typography color="secondary" variant="h6">{title}</Typography>
            <Tooltip title="You can press ESC on your keyboard to dismiss"><Button endIcon={<EastRoundedIcon />} onClick={handleClose} >cancel</Button></Tooltip>
          </div>

          <hr />
          <div className='mt-5 overflow-y-scroll flex flex-col gap-5 mb-[100px]'>

            <div className='mb-5'>You must either provide both a name and an address, or neither. You cannot provide only one.</div>

            <TextField label="Vanue Name"
              value={newClassData.venue?.name?.defaultValue.value ?? ""}
              slotProps={{ inputLabel: { shrink: true } }}
              type="search"
              required={required}
              onChange={e => { updateClassDataValue("name",e.target.value) }}
              error={required && !newClassData.venue?.name}
            />

            <TextField label="Vanue Address"
              value={newClassData.venue?.address?.defaultValue.value ?? ""}
              slotProps={{ inputLabel: { shrink: true } }}
              type="search"
              onChange={e => { updateClassDataValue("address",e.target.value) }}
              required={required}
              multiline
              minRows={5}
              error={required && !newClassData.venue?.address}
            />

          </div>

          <div className='fixed bottom-5 w-[460px]'>
            <hr className='mb-5' />
            <div className="flex flex-row gap-5 justify-end">
              <Button variant="contained" disabled={!dataChanged && valid} onClick={saveFormData}>Save</Button>
            </div>
          </div>

        </div>
      </PopupShell>
    )

}

export default PopupDialogText
